import {State} from "@hookstate/core";

export function cloneState<T>(state: State<T, any>): T {
    const unproxied = state.get({noproxy: true});
    if (!unproxied) {
        return unproxied as T;
    }

    return JSON.parse(JSON.stringify(unproxied)) as T;
}